import type { Model } from '@patsnap/tahiti-core/common/model';
import type { DualViewRef } from '../types';

export const DualViewRefModel = Symbol.for('DualViewRefModel');

export interface DualViewRefModel extends Model<DualViewRef> {}
